import type { ReactNode } from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';

/**
 * Renders a React node to a template
 * @param node The React node to render
 * @returns The template element containing the HTML render of the node
 * @see https://react.dev/reference/react-dom/server/renderToString#removing-rendertostring-from-the-client-code
 */
export function renderToTemplate(node: ReactNode): HTMLTemplateElement {
  const template = document.createElement('template');
  const container = document.createElement('div');
  const root = createRoot(container);
  flushSync(() => {
    root.render(node);
  });
  template.innerHTML = container.innerHTML;
  return template;
}
